import { Containner, BoxGroup } from "./styled";

const CarbonCertificate = () => {
  return (
    <Containner>
      <h1>Carbon Certificate</h1>
      <p>
        Carbon certificates are tradable permits to offset carbon emissions. One
        carebon certificate is equivalent to one metric ton of CO2 or equivalent
        greenhouse gases. Companies can buy carbon certificates in renewable
        energy project to offset their carbon emissions.
      </p>
      <p>
        With the world facing urgent climate challenges, carbon certificates are
        more important than ever as a way for businesses and organizations to
        take action on climate change and create a sustainable future.
      </p>
      <BoxGroup>
        <div>
          <h1>01</h1>
          <h2>Meeting sustainability goals:</h2>
          <p>
            Carbon certificates help businesses reduce carbon emissions to meet
            sustainability goals.
          </p>
        </div>
        <div>
          <h1>02</h1>
          <h2>Improving public perception:</h2>
          <p>
            Companies and organizations can improve public perception by
            demonstrating a commitment to reducing carbon emissions.
          </p>
        </div>
        <div>
          <h1>03</h1>
          <h2>Potential financial benefits:</h2>
          <p>
            The revenue from carbon certificates can fund renewable energy
            projects, providing financial benefits for companies while helping
            to address climate change.
          </p>
        </div>
      </BoxGroup>
    </Containner>
  );
};
export default CarbonCertificate;
